import { __assign } from 'tslib';
import { textInput } from './text-input.js';

var _a;
var textArea = {
    base: __assign(__assign({}, textInput.base), { width: "100%", height: "193px", outline: "none", margin: "auto", ":disabled": {
            backgroundColor: "black.5",
        }, ":focus": {
            boxShadow: "0 0 0 4px var(--colors-primary-20)",
            borderColor: "primary.100",
        } }),
    variants: {
        size: {
            sm: {
                fontSize: 2,
                padding: "6px 8px",
            },
            md: {
                padding: "10px 16px",
            },
            lg: {
                padding: "16px",
            },
        },
        invalid: __assign({}, (_a = textInput.variants) === null || _a === void 0 ? void 0 : _a.invalid),
    },
};

export { textArea };
//# sourceMappingURL=text-area.js.map
